<template>
  <f-container class="py-4">
    <f-row class="justify-content-center align-items-center text-center text-white">
      <f-col
          sm="5"
          md="5"
          lg="5"
          xl="5">
        <f-headline tag="h6" class="text-uppercase">
          Finde jetzt das richtige Auto Abo für dich
        </f-headline>
        <ul class="p-0 d-none d-lg-block">
          <li class="d-inline mr-2">1. Auto suchen</li>
          <li class="d-inline mr-2">2. Buchen</li>
          <li class="d-inline mr-2">3. Flexibel fahren</li>
        </ul>
      </f-col>
      <f-col
          sm="3"
          md="3"
          lg="3"
          xl="3"
      >
        <div class="col-lg-auto text-center px-lg-3 text-center">
          <f-button :to="catalogUrl" variant="primary" size="lg">
            Auto finden
          </f-button>
          <label class="d-none d-md-block pt-2">ohne Anmeldung</label>
        </div>
      </f-col>
    </f-row>
  </f-container>

</template>

<script>
    export default {
        name: "CTA-Bar",
        props: ['linkUrl', 'catalogUrl'],
    }
</script>

<style scoped>

</style>
